/* Lorenz QA fixes (Oct 2026)
   Loaded after custom-app.js from layout/theme.liquid.
   - Rows 17-18: product page quantity accepts whole numbers only and shows an inline
     stock-limit message instead of a browser alert.
   - Rows 14, 16, 19, 21: contact form (Powerful Form Builder app) field types,
     whitespace validation, scroll position on error, and error message wording. */

(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'complete') {
      fn();
    } else {
      window.addEventListener('load', fn, { once: true });
    }
  }

  /* --------------------------------------------------
     Rows 17-18: product page quantity
  -------------------------------------------------- */
  function initQuantityFixes() {
    var root = document.querySelector('.custom-single--product');
    if (!root) return;

    var input = root.querySelector('input[name="quantity"]');
    var totalEl = root.querySelector('#total-price');
    if (!input) return;

    // Numeric keyboard on mobile, whole numbers only
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('pattern', '[0-9]*');
    input.setAttribute('step', '1');

    // Remove the original handlers from custom-app.js (they used alert())
    if (window.jQuery) {
      window.jQuery(input).off('input change blur');
      window.jQuery(document).off(
        'click',
        '.custom-single--product .quantity-plus, .custom-single--product .quantity-minus'
      );
    }

    // Inline message element after the quantity selector
    var selector = input.closest('quantity-selector-component') || input.parentElement;
    var message = root.querySelector('.quantity__stock-message');
    if (!message) {
      message = document.createElement('span');
      message.className = 'quantity__stock-message';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      selector.insertAdjacentElement('afterend', message);
    }

    function showMessage(text) {
      message.textContent = text;
      message.classList.add('is-visible');
    }

    function hideMessage() {
      message.textContent = '';
      message.classList.remove('is-visible');
    }

    function getMax() {
      var fromData = parseInt(input.getAttribute('data-max-quantity'), 10);
      var fromAttr = parseInt(input.getAttribute('max'), 10);
      if (fromAttr > 0) return fromAttr;
      if (fromData > 0) return fromData;
      return 10; // fallback limit when inventory is not tracked (same as the original theme behavior)
    }

    function getMin() {
      var min = parseInt(input.getAttribute('min'), 10);
      return min > 0 ? min : 1;
    }

    function getBasePrice() {
      var priceEl = root.querySelector('product-price .custom-price--wrapper .price');
      if (!priceEl) return 0;
      return parseFloat(priceEl.textContent.replace(/[^0-9.-]+/g, '')) || 0;
    }

    function updateTotal(qty) {
      if (!totalEl) return;
      var total = getBasePrice() * qty;
      totalEl.textContent = '$' + total.toFixed(2);
    }

    function sanitize(showStockMessage) {
      var raw = String(input.value || '').trim();
      var qty = Math.floor(parseFloat(raw));
      var min = getMin();
      var max = getMax();

      if (isNaN(qty) || qty < min) qty = min;

      var exceeded = false;
      if (max > 0 && qty > max) {
        qty = max;
        exceeded = true;
      }

      if (String(qty) !== raw) input.value = qty;

      if (exceeded && showStockMessage) {
        showMessage('Only ' + max + ' item' + (max === 1 ? '' : 's') + ' available for this variant.');
      } else if (!exceeded) {
        hideMessage();
      }

      updateTotal(qty);
    }

    // Block characters that are not digits (., e, +, -)
    input.addEventListener('keydown', function (e) {
      if (['.', ',', 'e', 'E', '+', '-'].indexOf(e.key) !== -1) {
        e.preventDefault();
      }
    });

    input.addEventListener('input', function () {
      // Strip anything that is not a digit while typing
      var cleaned = String(input.value).replace(/[^0-9]/g, '');
      if (cleaned !== String(input.value)) input.value = cleaned;
      sanitize(true);
    });

    input.addEventListener('change', function () { sanitize(true); });
    input.addEventListener('blur', function () { sanitize(true); });

    root.addEventListener('click', function (e) {
      if (e.target.closest('.quantity-plus, .quantity-minus')) {
        setTimeout(function () { sanitize(true); }, 30);
      }
    });

    // Re-check when the variant / price changes
    var priceWrapper = root.querySelector('product-price');
    if (priceWrapper && window.MutationObserver) {
      new MutationObserver(function () { sanitize(false); }).observe(priceWrapper, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Final guard on add to cart: never submit a bad quantity
    var form = input.closest('form');
    if (form) {
      form.addEventListener('submit', function () { sanitize(true); }, true);
    }

    sanitize(false);
  }

  /* --------------------------------------------------
     Rows 14, 16, 19, 21: contact form (Powerful Form Builder)
  -------------------------------------------------- */
  function initContactFormFixes() {
    var app = document.querySelector('.globo-form-app, .globo-formbuilder');
    if (!app) return;

    var HEADER_OFFSET = 140;

    function looksLike(el, words) {
      var haystack = [
        el.getAttribute('name') || '',
        el.getAttribute('id') || '',
        el.getAttribute('placeholder') || '',
        el.getAttribute('aria-label') || '',
        el.getAttribute('data-name') || ''
      ].join(' ').toLowerCase();

      var control = el.closest('.globo-form-control');
      if (control) {
        var label = control.querySelector('label, .globo-label');
        if (label) haystack += ' ' + label.textContent.toLowerCase();
        haystack += ' ' + (control.getAttribute('data-type') || '').toLowerCase();
      }

      return words.some(function (w) { return haystack.indexOf(w) !== -1; });
    }

    // Row 14: correct input types so phones show the right keyboard
    function fixFieldTypes() {
      var inputs = app.querySelectorAll('input[type="text"], input:not([type])');
      Array.prototype.forEach.call(inputs, function (el) {
        if (looksLike(el, ['email', 'e-mail'])) {
          el.setAttribute('type', 'email');
          el.setAttribute('inputmode', 'email');
          el.setAttribute('autocomplete', 'email');
        } else if (looksLike(el, ['phone', 'tel', 'mobile'])) {
          el.setAttribute('type', 'tel');
          el.setAttribute('inputmode', 'tel');
          el.setAttribute('autocomplete', 'tel');
        }
      });
    }

    // Row 16: whitespace-only values count as empty
    function trimAll() {
      var fields = app.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input:not([type]), textarea');
      Array.prototype.forEach.call(fields, function (el) {
        if (typeof el.value === 'string' && el.value.trim() === '' && el.value !== '') {
          el.value = '';
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (typeof el.value === 'string' && el.value !== el.value.trim()) {
          el.value = el.value.trim();
          el.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }

    // Trim before the app's own validation runs (capture phase, so we are first)
    app.addEventListener('click', function (e) {
      if (e.target.closest('button[type="submit"], .gfb__footer button, input[type="submit"]')) {
        trimAll();
      }
    }, true);

    app.addEventListener('submit', trimAll, true);

    app.addEventListener('blur', function (e) {
      var el = e.target;
      if (el && typeof el.value === 'string' && el.matches('input, textarea') && el.value.trim() === '' && el.value !== '') {
        el.value = '';
      }
    }, true);

    // Row 21: clean up error message wording
    function cleanErrorText(node) {
      if (!node || node.dataset.qaCleaned === node.textContent) return;
      var text = node.textContent.replace(/\s+/g, ' ').trim();
      var original = text;

      // Consent / privacy checkbox
      if (/privacy/i.test(text) && /required|accept/i.test(text)) {
        text = 'Please accept the Privacy Policy.';
      } else {
        // "First name * is required" -> "First name is required"
        text = text.replace(/\s*\*\s*/g, ' ').replace(/\s{2,}/g, ' ').trim();
        text = text.replace(/\s+\./g, '.');
        if (/is required$/i.test(text) && !/\.$/.test(text)) text += '.';
      }

      if (text !== original) node.textContent = text;
      node.dataset.qaCleaned = node.textContent;
    }

    function cleanAllErrors() {
      var errors = app.querySelectorAll('.help-block.error, .help-block, .globo-form-control .error, .text-danger');
      Array.prototype.forEach.call(errors, cleanErrorText);
    }

    // Row 19: first invalid field scrolls fully into view under the sticky header
    var scrollTimer = null;
    function scrollToFirstError() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var first = app.querySelector('.globo-form-control.has-error, .has-error');
        if (!first) return;
        var top = first.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        var focusable = first.querySelector('input, textarea, select');
        if (focusable) {
          try { focusable.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
        }
      }, 80);
    }

    fixFieldTypes();
    cleanAllErrors();

    if (window.MutationObserver) {
      var pendingScroll = false;
      new MutationObserver(function (mutations) {
        var errorAppeared = false;
        mutations.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            if (m.target.classList && m.target.classList.contains('has-error')) errorAppeared = true;
          }
          if (m.type === 'childList' && m.addedNodes.length) {
            Array.prototype.forEach.call(m.addedNodes, function (n) {
              if (n.nodeType !== 1) return;
              if (n.matches && (n.matches('.help-block, .error, .text-danger') || n.querySelector('.help-block, .error, .text-danger'))) errorAppeared = true;
            });
          }
        });
        fixFieldTypes();
        cleanAllErrors();
        if (errorAppeared && !pendingScroll) {
          pendingScroll = true;
          scrollToFirstError();
          setTimeout(function () { pendingScroll = false; }, 400);
        }
      }).observe(app, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  onReady(function () {
    initQuantityFixes();
    initContactFormFixes();
  });
})();
